import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../css/footer.scss";
import { siteConfig, siteMedia } from "../Datas/productData";

function Footer() {
  const location = useLocation();
  const isCheckout = ["/checkout", "/payment"].includes(location.pathname);

  if (isCheckout) {
    return (
      <footer className="checkout-footer">
        <span>
          © {new Date().getFullYear()} {siteConfig.brandName}
        </span>
        <nav aria-label="Checkout policies">
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/returns">Returns</Link>
          <Link to="/cookies">Cookies</Link>
          <Link to="/policies">All policies</Link>
        </nav>
      </footer>
    );
  }

  return (
    <footer className="site-footer" role="contentinfo">
      <section
        className="values-band"
        aria-label={`${siteConfig.brandName} values`}
      >
        <div className="values-band__inner">
          <article>
            <svg viewBox="0 0 64 64" aria-hidden="true">
              <path d="M32 6 17 26h9L12 45h40L38 26h9L32 6Z" />
              <path d="M32 45v13" />
            </svg>
            <div>
              <strong>Considered</strong>
              <span>Partners chosen with care</span>
            </div>
          </article>
          <article>
            <svg viewBox="0 0 64 64" aria-hidden="true">
              <path d="M8 30c8-11 18-10 24 0 6-10 16-11 24 0-7 14-17 21-24 26C25 51 15 44 8 30Z" />
              <path d="M20 25c2 4 6 7 12 7s10-3 12-7" />
            </svg>
            <div>
              <strong>Approachable</strong>
              <span>Honest by design</span>
            </div>
          </article>
          <article>
            <svg viewBox="0 0 64 64" aria-hidden="true">
              <path d="m7 31 49-20-18 45-8-18-23-7Z" />
              <path d="m30 38 26-27" />
            </svg>
            <div>
              <strong>Innovative</strong>
              <span>Materials with a future</span>
            </div>
          </article>
          <article>
            <svg viewBox="0 0 64 64" aria-hidden="true">
              <path d="M19 10h26l9 13-9 8v23H19V31l-9-8 9-13Z" />
              <path d="M25 10c1 7 13 7 14 0M19 31h26" />
            </svg>
            <div>
              <strong>Skillful</strong>
              <span>Textile knowledge that lasts</span>
            </div>
          </article>
        </div>
      </section>

      <section className="footer-landscape" aria-label="Follow nature">
        <img
          src={siteMedia.forest}
          alt="A quiet path through a misty spruce forest"
        />
        <div className="footer-landscape__overlay">
          <p>#pningwillow</p>
          <span>Useful materials for everyday journeys.</span>
        </div>
      </section>

      <div className="footer-main">
        <div className="footer-main__grid">
          <div className="footer-brand">
            <Link to="/" aria-label={`${siteConfig.brandName} home`}>
              <img src={siteConfig.logo} alt={siteConfig.brandName} />
            </Link>
            <p>{siteConfig.description}</p>
          </div>

          <div className="footer-column">
            <h2>Contact</h2>
            <p>Product guidance, customer care and our business address.</p>
            <address className="footer-contact">
              <a href={`mailto:${siteConfig.contact.email}`}>
                {siteConfig.contact.email}
              </a>
              <span>{siteConfig.contact.address}</span>
            </address>
          </div>

          <div className="footer-column footer-newsletter">
            <h2>Customer care</h2>
            <p>
              Find quick answers about ordering, delivery, returns and how this
              site uses cookies.
            </p>
            <Link className="text-link" to="/faqs">
              Read FAQs →
            </Link>
          </div>

          <div className="footer-column footer-menu">
            <h2>Menu</h2>
            <nav aria-label="Footer navigation">
              <Link to="/about">Our story</Link>
              <Link to="/contact">Contact</Link>
              <Link to="/shipping">Shipping</Link>
              <Link to="/returns">Returns</Link>
              <Link to="/terms">Terms & conditions</Link>
              <Link to="/privacy">Privacy</Link>
              <Link to="/cookies">Cookie policy</Link>
              <Link to="/policies/payments-billing">Payments</Link>
              <Link to="/policies/refunds">Refunds</Link>
              <Link to="/policies/accessibility">Accessibility</Link>
              <Link to="/policies/legal-notice">Legal notice</Link>
              <Link to="/policies">All policies</Link>
              <Link to="/faqs">FAQs</Link>
            </nav>
          </div>
        </div>

        <div className="footer-aside">
          <div className="footer-selects" aria-label="Regional preferences">
            <span>{siteConfig.country} (USD $)</span>
            <span>English</span>
          </div>
          <span>
            © {new Date().getFullYear()} {siteConfig.brandName}
          </span>
          <div className="payment-badges" aria-label="Accepted payment methods">
            <span>VISA</span>
            <span>Mastercard</span>
            <span>AMEX</span>
            <span>PayPal</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
